import React from 'react';
import { connect } from 'react-redux';
import { Skeleton } from '@mui/material';
import { getWFResizer } from '@/redux/User/user.reducer';
import { WF_STATUS_WIDTH } from '@/helpers/constants';
import styles from './SkeletonsStyles.module.scss';

const StateStatusSkeletonExpanded = () => (
  <>
    <div className={styles.HeaderSkeletonRow}>
      <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'center' }}>
        <Skeleton variant="circular" width={42} height={42} />
        <Skeleton variant="text" width='75%' height={42} />
      </div>
    </div>
    <div className={styles.HeaderSkeletonRow}>
      <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'flex-end' }}>
        <Skeleton variant="text" width='75%' height={42} />
      </div>
    </div>
    <div className={styles.HeaderSkeletonRow}>
      <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'flex-end' }}>
        <Skeleton variant="text" width='75%' height={42} />
      </div>
    </div>
  </>);

const StateStatusSkeletonCollapsed = () => (
  <div className={styles.HeaderSkeletonRow}>
    <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'center' }}>
      <Skeleton variant="circular" width={42} height={42} />
      <Skeleton variant="text" width='30%' height={42} />
    </div>
  </div>);

interface CampaignStatusSkeletonProps {
  resizerWidth: number;
}

const CampaignStatusSkeleton: React.FC<CampaignStatusSkeletonProps> = (props) => {
  const { resizerWidth } = props;
  const isWFOpen = resizerWidth > WF_STATUS_WIDTH.THRESHOLD;

return (
  <div className={styles.CRStatusSkeleton} style={{ width: `${resizerWidth}px` }}>
    {isWFOpen && (
      <>
      { /* Collapse button & section title */}
      <div className={styles.HeaderSkeletonRow}>
        <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'center' }}>
          <Skeleton variant="circular" width={42} height={42} />
          <Skeleton variant="text" width='75%' height={42} />
        </div>
      </div>
      <br />
      { /* Expanded/normal view button */}
      <div className={styles.HeaderSkeletonRow}>
        <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'center' }}>
          <Skeleton variant="rectangular" width='60%' height={42} />
        </div>
      </div>
      <br /><br />
      { /* Some Steps */}
      <StateStatusSkeletonExpanded />
      <br /><br />
      <StateStatusSkeletonExpanded />
      <br /><br />
      <StateStatusSkeletonExpanded />
      <br /><br />
      <StateStatusSkeletonExpanded />
    </>
    )}
    {!isWFOpen && (
      <>
        <div className={styles.HeaderSkeletonRow}>
          <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'center' }}>
            <Skeleton variant="circular" width={42} height={42} />
          </div>
        </div>
        <br />
        <div className={styles.HeaderSkeletonRow}>
          <div className={styles.HeaderSkeletonColumn} style={{ justifyContent: 'center' }}>
            <Skeleton variant="rectangular" width='75%' height={62} />
          </div>
        </div>
        <br /><br />
        { /* Some Steps */}
        <StateStatusSkeletonCollapsed />
        <br />
        <StateStatusSkeletonCollapsed />
        <br />
        <StateStatusSkeletonCollapsed />
        <br />
        <StateStatusSkeletonCollapsed />
      </>
    )}
  </div>
);
};


const mapStateToProps = (state) => ({
  resizerWidth: getWFResizer(state),
});


export default connect(mapStateToProps)(CampaignStatusSkeleton);
